import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicNav from '../components/dna/PublicNav';
import Footer from '../components/dna/Footer';

const sections = [
  { id: 'introduction', title: 'Introduction' },
  { id: 'collecte', title: '1. Données collectées' },
  { id: 'finalites', title: '2. Finalités du traitement' },
  { id: 'partage', title: '3. Partage des données' },
  { id: 'conservation', title: '4. Conservation des données' },
  { id: 'droits', title: '5. Vos droits' },
  { id: 'securite', title: '6. Sécurité' },
  { id: 'cookies', title: '7. Cookies' },
  { id: 'contact', title: '8. Contact' },
];

export default function PrivacyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const offset = 80;
      const top = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: top - offset, behavior: 'smooth' });
    }
  };

  return (
    <div className="site-shell legal-page"><PublicNav /><div className="passio-terms-page">
      <header className="passio-terms-header">
        <div className="passio-terms-header-inner">
          <Link to="/" className="passio-terms-logo">
            <img src="/assets/Logo.png" alt="Pass'io" />
          </Link>
          <nav className="passio-terms-nav">
            <Link to="/" className="passio-terms-back">
              <i className="fas fa-arrow-left" /> Retour à l'accueil
            </Link>
          </nav>
        </div>
      </header>

      <div className="passio-terms-container">
        <aside className="passio-terms-sidebar">
          <div className="passio-terms-sidebar-inner">
            <h3 className="passio-terms-sidebar-title">Sommaire</h3>
            <nav className="passio-terms-toc">
              {sections.map((s) => (
                <button key={s.id} onClick={() => scrollToSection(s.id)} className="passio-terms-toc-link">
                  {s.title}
                </button>
              ))}
            </nav>
          </div>
        </aside>

        <main className="passio-terms-content">
          <div className="passio-terms-hero">
            <span className="passio-terms-badge">Version 1.0</span>
            <h1 className="passio-terms-title">Politique de Confidentialité</h1>
            <p className="passio-terms-meta">
              <strong>Date d'entrée en vigueur :</strong> 1er Mai 2026
            </p>
            <p className="passio-terms-meta">
              <strong>Dernière mise à jour :</strong> Juillet 2026
            </p>
          </div>

          <section id="introduction" className="passio-terms-section">
            <h2>Introduction</h2>
            <p>
              Pass'io s'engage à protéger la vie privée de ses utilisateurs — artistes et fans.
              La présente politique de confidentialité explique quelles données sont collectées,
              comment elles sont utilisées, et quels droits vous avez concernant vos informations personnelles.
            </p>
            <p>
              En utilisant la plateforme Pass'io (site web, application mobile, bot Telegram),
              vous acceptez les pratiques décrites dans ce document.
            </p>
            <div className="passio-terms-notice">
              <i className="fas fa-shield-halved" />
              <p>
                <strong> Notre engagement :</strong> Nous ne vendons jamais vos données personnelles.
                Vos informations sont utilisées uniquement pour faire fonctionner et améliorer la plateforme.
              </p>
            </div>
          </section>

          <section id="collecte" className="passio-terms-section">
            <h2>1. Données collectées</h2>

            <h3>1.1 Données fournies volontairement</h3>
            <p>Lors de votre inscription et utilisation de la plateforme, vous nous fournissez :</p>
            <ul>
              <li><strong>Artistes :</strong> nom, prénom, email, numéro de téléphone, numéro Mobile Money, pseudonyme artistique</li>
              <li><strong>Fans :</strong> numéro de téléphone (uniquement lors d'un paiement), historique d'achats, identifiant d'appareil (Device ID)</li>
              <li><strong>Contenu :</strong> œuvres musicales, pochettes d'albums, descriptions, paroles</li>
            </ul>

            <h3>1.2 Données collectées automatiquement</h3>
            <p>Lors de votre navigation et utilisation, nous collectons automatiquement :</p>
            <ul>
              <li><strong>Données techniques :</strong> adresse IP, type de navigateur, version du système d'exploitation</li>
              <li><strong>Données d'utilisation :</strong> pages visitées, actions effectuées, durée des sessions</li>
              <li><strong>Identifiant d'appareil :</strong> pour lier votre Pass'Code à votre appareil mobile</li>
            </ul>

            <h3>1.3 Données de paiement</h3>
            <p>
              Pass'io ne stocke <strong>aucune information de carte bancaire ou de code secret Mobile Money</strong>.
              Les transactions sont traitées directement via les APIs MVola et Orange Money.
              Nous conservons uniquement une trace de la transaction (montant, date, référence) pour la gestion des ventes.
            </p>
          </section>

          <section id="finalites" className="passio-terms-section">
            <h2>2. Finalités du traitement</h2>
            <p>Vos données sont utilisées exclusivement pour :</p>
            <ul>
              <li><strong>Gestion des comptes :</strong> création, authentification, maintenance de votre profil</li>
              <li><strong>Traitement des transactions :</strong> gestion des paiements, génération des Pass'Codes, versement des gains</li>
              <li><strong>Protection anti-piratage :</strong> liaison des Pass'Codes aux appareils pour empêcher le partage illégal</li>
              <li><strong>Communication :</strong> notifications Telegram pour les ventes, emails administratifs (factures, mises à jour importantes)</li>
              <li><strong>Amélioration du service :</strong> analyse des statistiques d'utilisation anonymisées</li>
              <li><strong>Lutte contre la fraude :</strong> détection des comportements suspects et protection de l'intégrité de la plateforme</li>
            </ul>
            <p>
              Nous n'utilisons <strong>jamais</strong> vos données à des fins de publicité ciblée, de revente à des tiers,
              ou de profilage commercial non lié au fonctionnement de la plateforme.
            </p>
          </section>

          <section id="partage" className="passio-terms-section">
            <h2>3. Partage des données</h2>
            <p>Vos données peuvent être partagées uniquement dans les cas suivants :</p>

            <div className="passio-terms-table-wrapper">
              <table className="passio-terms-table">
                <thead>
                  <tr>
                    <th>Destinataire</th>
                    <th>Données partagées</th>
                    <th>Finalité</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>MVola / Orange Money</strong></td>
                    <td>Numéro de téléphone, montant de la transaction</td>
                    <td>Traitement des paiements</td>
                  </tr>
                  <tr>
                    <td><strong>Cloudinary</strong></td>
                    <td>Fichiers audio et images (pochettes)</td>
                    <td>Hébergement et diffusion</td>
                  </tr>
                  <tr>
                    <td><strong>Backblaze B2</strong></td>
                    <td>Fichiers audio chiffrés</td>
                    <td>Stockage sécurisé</td>
                  </tr>
                  <tr>
                    <td><strong>Telegram</strong></td>
                    <td>Identifiant Telegram (uniquement si configuré)</td>
                    <td>Notifications bot</td>
                  </tr>
                  <tr>
                    <td><strong>Autorités légales</strong></td>
                    <td>Sur demande légale uniquement</td>
                    <td>Obligation légale</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p>
              Pass'io ne partage <strong>jamais</strong> vos données avec des partenaires commerciaux,
              régies publicitaires ou toute autre tierce partie à des fins non essentielles au service.
            </p>
          </section>

          <section id="conservation" className="passio-terms-section">
            <h2>4. Conservation des données</h2>
            <p>Nous conservons vos données selon les durées suivantes :</p>
            <ul>
              <li><strong>Comptes actifs :</strong> les données sont conservées pendant toute la durée d'utilisation de la plateforme</li>
              <li><strong>Comptes fermés :</strong> les données sont conservées <strong>3 ans</strong> après la clôture du compte pour des raisons légales et fiscales</li>
              <li><strong>Transactions :</strong> conservées <strong>5 ans</strong> conformément aux obligations comptables malgaches</li>
              <li><strong>Journaux techniques :</strong> conservés <strong>90 jours</strong> maximum</li>
            </ul>
            <p>
              Après expiration de ces durées, toutes les données personnelles sont définitivement supprimées
              ou anonymisées de manière irréversible.
            </p>
          </section>

          <section id="droits" className="passio-terms-section">
            <h2>5. Vos droits</h2>
            <p>Conformément à la réglementation malgache applicable, vous disposez des droits suivants :</p>

            <div className="passio-terms-table-wrapper">
              <table className="passio-terms-table">
                <thead>
                  <tr>
                    <th>Droit</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>Accès</strong></td>
                    <td>Obtenir une copie de toutes les données que nous détenons sur vous</td>
                  </tr>
                  <tr>
                    <td><strong>Rectification</strong></td>
                    <td>Corriger les informations inexactes ou incomplètes</td>
                  </tr>
                  <tr>
                    <td><strong>Suppression</strong></td>
                    <td>Demander la suppression de vos données (sous réserve des obligations légales)</td>
                  </tr>
                  <tr>
                    <td><strong>Opposition</strong></td>
                    <td>Vous opposer au traitement de vos données pour certains motifs légitimes</td>
                  </tr>
                  <tr>
                    <td><strong>Portabilité</strong></td>
                    <td>Recevoir vos données dans un format structuré et lisible</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p>
              Pour exercer l'un de ces droits, contactez-nous à{' '}
              <a href="mailto:contact@passio.mg">contact@passio.mg</a>.
              Nous répondons à toutes les demandes sous <strong>14 jours calendaires</strong>.
            </p>
          </section>

          <section id="securite" className="passio-terms-section">
            <h2>6. Sécurité</h2>
            <p>
              Pass'io met en œuvre des mesures techniques et organisationnelles robustes pour protéger vos données :
            </p>
            <ul>
              <li><strong>Chiffrement AES-256</strong> des fichiers audio — même nos administrateurs ne peuvent pas lire votre musique sans votre accord</li>
              <li><strong>HTTPS</strong> sur l'ensemble du site — toutes les communications sont chiffrées</li>
              <li><strong>Stockage séparé</strong> des clés de déchiffrement et des données</li>
              <li><strong>Accès restreint</strong> — seuls les administrateurs essentiels ont accès aux données sensibles</li>
              <li><strong>Audits réguliers</strong> de sécurité et revue des accès</li>
            </ul>
            <div className="passio-terms-notice">
              <i className="fas fa-lock" />
              <p>
                <strong>Important :</strong> Aucun système n'est inviolable à 100%. Nous nous engageons à vous
                notifier sans délai en cas de brèche de sécurité affectant vos données personnelles.
              </p>
            </div>
          </section>

          <section id="cookies" className="passio-terms-section">
            <h2>7. Cookies</h2>
            <p>
              Pass'io utilise uniquement des cookies <strong>strictement nécessaires</strong> au fonctionnement
              de la plateforme :
            </p>
            <ul>
              <li><strong>Cookie de session :</strong> pour maintenir votre connexion active</li>
              <li><strong>Cookie CSRF :</strong> pour protéger contre les attaques de type Cross-Site Request Forgery</li>
            </ul>
            <p>
              Nous n'utilisons <strong>aucun cookie</strong> de traçage publicitaire, de réseaux sociaux ou
              d'analyse tiers. Notre page ne comporte pas de pixels Meta, Google Analytics ou autres traceurs.
            </p>
          </section>

          <section id="contact" className="passio-terms-section">
            <h2>8. Contact</h2>
            <p>
              Pour toute question concernant cette politique de confidentialité ou l'exercice de vos droits,
              vous pouvez nous contacter :
            </p>
            <ul>
              <li><strong>Email :</strong> <a href="mailto:contact@passio.mg">contact@passio.mg</a></li>
              <li><strong>Adresse :</strong> Antananarivo, Madagascar</li>
              <li><strong>Délai de réponse :</strong> sous 14 jours calendaires maximum</li>
            </ul>
            <p>
              Nous nous réservons le droit de modifier la présente politique de confidentialité.
              Toute modification vous sera notifiée par email avec un préavis minimum de <strong>30 jours</strong>.
            </p>
          </section>

          <footer className="passio-terms-footer">
            <p>
              Pass'io — Politique de Confidentialité — Version 1.0 — Entrée en vigueur le 1er Mai 2026
            </p>
            <p>
              Document susceptible d'être mis à jour. Consultez toujours la version en vigueur sur{' '}
              <a href="https://artist.passio.mg">artist.passio.mg</a>
            </p>
            <p>
              <Link to="/terms" style={{ color: '#780000', fontWeight: 600 }}>Consulter les CGU</Link>
              {' · '}
              <Link to="/legal" style={{ color: '#780000', fontWeight: 600 }}>Mentions Légales</Link>
            </p>
          </footer>
        </main>
      </div>
      </div>
      <Footer />
    </div>
  );
}
